// @flow
import * as messageBus from '@wh/message-bus';
import config from '@wh/tracking-logic/lib/config';
import { ANALYTICS_ADAPTER_READY } from '../constants';

const { TOPICS } = config;

const whenReady = (callback: () => void) => {
  const token = messageBus.subscribe(ANALYTICS_ADAPTER_READY, () => {
    messageBus.unsubscribe(token);
    callback();
  });
};

export const track = (payload: *) =>
  whenReady(() => {
    messageBus.publish(TOPICS.EVENT_PARTIAL, payload);
  });
